import { render, staticRenderFns } from "./identify-the-problem-and-fine-tune-your-product.vue?vue&type=template&id=ab82e838&"
import script from "./identify-the-problem-and-fine-tune-your-product.vue?vue&type=script&lang=js&"
export * from "./identify-the-problem-and-fine-tune-your-product.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports